import React from 'react'
import './footer.css'
import {BsFacebook} from 'react-icons/bs'
import { FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <footer id="footer">
      <motion.span 
        href="#header" 
        className="footer__logo"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        NovzChron
      </motion.span>

      <motion.ul 
        className="footer__links"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.li variants={itemVariants}>
          <a href="#header">{t.home}</a>
        </motion.li>
        <motion.li variants={itemVariants}>
          <a href="#propos">{t.about}</a>
        </motion.li>
        <motion.li variants={itemVariants}>
          <a href="#experience">{t.experience}</a>
        </motion.li>
        <motion.li variants={itemVariants}>
          <a href="#portfolio">{t.portfolio}</a>
        </motion.li>
        <motion.li variants={itemVariants}>
          <a href="#contact">{t.contact}</a>
        </motion.li>
      </motion.ul>

      <motion.div 
        className="footer__socials"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <motion.a 
          href="https://x.com/traorelamine1" 
          rel="noreferrer"
          whileHover={{ 
            scale: 1.2,
            y: -5,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.9 }}
        >
          <FaXTwitter />
        </motion.a>
        <motion.a 
          href="https://web.facebook.com/lamine.traore.1998/" 
          rel="noreferrer"
          whileHover={{ 
            scale: 1.2,
            y: -5,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.9 }}
        >
          <BsFacebook />{" "}
        </motion.a>
        <motion.a
          href="https://www.linkedin.com/in/traore-lamine-84bb7423a/"
          rel="noreferrer"
          whileHover={{ 
            scale: 1.2,
            y: -5,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.9 }}
        >
          <FaLinkedinIn />
        </motion.a>
      </motion.div>
      
      <motion.div 
        className="footer__copyright"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        viewport={{ once: true }}
      >
        <small>&copy; NovzChron. {t.footerText}.</small>
      </motion.div>
    </footer>
  );
}

export default Footer